import { Modal, ModalProps } from '@hhgtech/hhg-components/mantine'

import useStyles from './index.styles'
import AirPopulation from '..'
import { Body } from '../Body'

export const ModalDetail = ({ className, ...props }: ModalProps) => {
  const { classes } = useStyles(undefined, {
    name: 'AirPopulation__ModalDetail',
  })
  return (
    <AirPopulation selectorZIndex={500}>
      {(data) => (
        <Modal
          {...props}
          title={data?.cardInfo?.title}
          size={600}
          classNames={{ body: classes.modalBody }}
          zIndex={500}
        >
          <Body className={classes.body} />
          <AirPopulation.Disclaimer className={classes.disclaimer} />
        </Modal>
      )}
    </AirPopulation>
  )
}
